import { registerFormRules } from "./utils/FormValidation";
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store'
import Axios from 'axios'
import {installSessionInterceptor} from './common/sessionInterceptor';
import {getEnglishValidatorLocale} from './config/brand';

import {
    BootstrapVue,
    IconsPlugin,
    // LayoutPlugin,
    // ModalPlugin,
    // CardPlugin,
    // VBScrollspyPlugin,
    // DropdownPlugin,
    // TablePlugin,
} from 'bootstrap-vue'

// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import './custom.css'
// import './asset/themes/darkly.min.css'
// import 'custom1.scss'
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from "vee-validate";
import en from "./lang/validator/en.json";
import ru from "./lang/validator/ru.json";
import * as rules from "vee-validate/dist/rules";
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false;
// Install VeeValidate rules and localization
Object.entries(rules).forEach(([name, rule]) => {
    extend(name, rule);
});

registerFormRules();

localize("en", getEnglishValidatorLocale(en));
localize("ru", ru);


Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.prototype.$http = Axios;
const token = localStorage.getItem('token')
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

installSessionInterceptor(Axios, store, router);

new Vue({
    store,
    router,
    i18n,
      render: h => h(App),
    }
).$mount('#app');

import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

// Vue.use(LayoutPlugin);
// Vue.use(ModalPlugin);
// Vue.use(CardPlugin);
// Vue.use(VBScrollspyPlugin);
// Vue.use(DropdownPlugin);
// Vue.use(TablePlugin);
